import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="bg-pilates-cream py-20 px-4 sm:px-6 lg:px-8" data-id="element-119">
      <div className="max-w-3xl mx-auto text-center" data-id="element-120">
        <div className="border border-pilates-blue-dark text-pilates-blue-dark font-semibold text-xs px-4 py-1.5 mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-121">
          YOUR INVESTMENT IS 100% PROTECTED
        </div>
        <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-pilates-blue-dark leading-tight mb-8 tracking-tight" data-id="element-122">
          <span className="italic text-pilates-rose" data-id="element-123">30-Day</span> Money-Back
          Guarantee
        </h2>

        <div className="bg-white rounded-lg p-8 sm:p-10 shadow-md border border-pilates-slate/10 relative" data-id="element-124">
          <div className="relative w-24 h-24 mx-auto mb-8 flex items-center justify-center" data-id="element-125">
            {/* Medal outer ring */}
            <div className="absolute inset-0 rounded-full border-2 border-pilates-blue-dark" data-id="element-126"></div>
            {/* Medal inner gold circle */}
            <div className="absolute inset-1 rounded-full bg-pilates-lavender flex items-center justify-center shadow-inner" data-id="element-127">
              <ShieldCheck className="w-10 h-10 text-pilates-blue-dark" data-id="element-128" />
            </div>
            {/* Ribbon label */}
            <div className="absolute -top-3 bg-pilates-blue-dark text-white text-[10px] font-bold px-3 py-1 uppercase tracking-widest rounded-sm shadow-sm whitespace-nowrap" data-id="element-129">
              30-DAY GUARANTEE
            </div>
          </div>

          <h3 className="font-display text-2xl font-semibold text-pilates-blue-dark mb-4" data-id="element-130">
            Your investment is 100% protected
          </h3>
          <p className="text-pilates-slate text-base sm:text-lg leading-relaxed" data-id="element-131">
            You have 30 full days to explore the 6 volumes, apply the drills on
            the court, and evaluate the results. If you are not fully satisfied,
            we will refund you in full. ZERO risk for you, total commitment from
            us.
          </p>
        </div>
      </div>
    </section>;
}